export default __webpack_public_path__ + "e944e3464e04a0300a36d065e9c28e46.svg";